import { trpc } from "@/lib/trpc";
import { toast } from "sonner";
import { fromError } from "zod-validation-error";

export const useCreateThreadMutation = (
    setLoading?: (loading: boolean) => void,
    setError?: (error: string) => void
) => {
    const utils = trpc.useUtils();
    return trpc.threads.create.useMutation({
        onMutate: async () => {
            if (setLoading) setLoading(true);
            if (setError) setError("");
        },
        onSuccess: async () => {
            utils.threads.findMany.invalidate();
            // toast.success("Thread created successfully");
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
            return setError && setError(errorMessage);
        },
        onSettled: async () => {
            return setLoading && setLoading(false);
        },
    });
};

export const useUpdateThreadMutation = (
    setLoading?: (loading: boolean) => void,
    setError?: (error: string) => void
) => {
    const utils = trpc.useUtils();
    return trpc.threads.update.useMutation({
        onMutate: async () => {
            if (setLoading) setLoading(true);
            if (setError) setError("");
        },
        onSuccess: async (data) => {
            utils.threads.findMany.invalidate();
            utils.threads.findOne.invalidate(data.id);
            toast.success("Thread updated successfully");
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
            return setError && setError(errorMessage);
        },
        onSettled: async () => {
            return setLoading && setLoading(false);
        },
    });
};

export const useDeleteThreadMutation = () => {
    const utils = trpc.useUtils();
    return trpc.threads.delete.useMutation({
        onSuccess: async (_, variables) => {
            utils.threads.findMany.invalidate();
            variables.forEach((id) => {
                utils.threads.findMany.invalidate();
                utils.threads.findOne.invalidate(id);
            });
            toast.success(`Thread${variables.length > 1 ? "s" : ""} deleted successfully`);
        },
        onError: async (error: any) => {
            console.log(error);
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
        },
    });
};
